// import i18n resources
import { createI18n } from 'vue-i18n'

import translations from '../locales/translations.json'

const lang = import.meta.env?.VITE_VUE_APP_LOCALE ?? process.env.VITE_VUE_APP_LOCALE

export const i18n = createI18n({
  legacy: false,
  locale: lang,
  messages: {
    [lang]: translations,
  },
})

export const localeToCountry = (locale: string) => {
  return locale === 'cs' ? 'cz' : locale
}

export const countryToLocale = (country: string) => {
  return country === 'cz' ? 'cs' : country
}

export const localizedRoutes = (slug: string, data: Record<string, string> = {}) => {
  const keys = Object.keys(data)
  let msg = (translations.path as Record<string, string>)[slug.replace('path.', '')]
  if (keys.length > 0) {
    for (const [i, key] of keys.entries()) {
      msg = msg.replace(`{${key}}`, Object.values(data)[i])
    }
  }
  return msg
}

export const localizedLocale = () => {
  const locale = (translations.locale as string)
  return locale
}
